import React from "react";
import Card from "../UI/Card";

import styles from "./QuoteList.module.css";

const QuoteList = (props) => {
  return (
    <Card>
      <section className={styles.itemsList}>
        <div className={styles.parentWrapper}>
          <div className={styles.lrow}>
            <div className={styles.child1}>
              <span>Quote Id</span>
            </div>
            <div className={styles.child1}>
              <span>Quote Name</span>
            </div>
            <div className={styles.child1}>
              <span>Quote Expiry Date</span>
            </div>
            <div className={styles.child1}>
              <span>Quote Status</span>
            </div>
          </div>
          <div className={styles.lrows}>{props.quoteList}</div>
        </div>
      </section>
    </Card>
  );
};

export default QuoteList;
